import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { TokenService } from './token.service';

@Injectable({
    providedIn: 'root',
})
export class SessionService {
    constructor(
        private tokenService: TokenService,
        private router: Router
    ) { }

    /**
     * Cierra la sesión del usuario
     */
    logout(): void {
        this.tokenService.deleteToken();
        localStorage.removeItem('merchantValidationData');
        this.clearSessionData();
        // Redirigir al login
        this.router.navigate(['/login']);
    }

    /**
     * Verifica si el usuario está autenticado
     */
    isAuthenticated(): boolean {
        const token = this.tokenService.getToken();
        return !!token && !this.tokenService.isTokenExpired();
    }

    /**
     * Maneja el token inválido o vencido
     */
    handleInvalidToken(): void {
        console.warn('Token inválido o vencido. Cerrando sesión...');
        this.logout();
    }

    clearADData(): void {
        localStorage.removeItem('merchantValidationData');
    }

    hasValidADData(): boolean {
        const adData = localStorage.getItem('merchantValidationData');
        if (!adData) return false;

        try {
            const parsed = JSON.parse(adData);
            // Verificar que tenga la estructura esperada
            return parsed && parsed.merchantCode && parsed.apiKeys;
        } catch (error) {
            return false;
        }
    }

    getADData(): any {
        const adData = localStorage.getItem('merchantValidationData');
        if (!adData) return null;

        try {
            return JSON.parse(adData);
        } catch (error) {
            console.warn('Error al parsear datos de AD:', error);
            return null;
        }
    }

    private clearSessionData(): void {
        // Limpiar datos específicos de la aplicación
        const keysToRemove = [
            'merchantValidationData',
            'domain',
            'modules',
            'merchants',
            'profile',
            'sidenav_settings_cache'
        ];

        keysToRemove.forEach(key => {
            localStorage.removeItem(key);
        });

    }

    clearAllSessionData(): void {
        localStorage.clear();
    }
}
